// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bw-space-between label input:focus+div svg{outline:#0c0243 .1rem solid;outline-offset:.2rem;border-radius:100%}@media only screen and (min-width: 1024px)and (max-width: 1599px){.bw-horizontal{flex-wrap:nowrap}}@media only screen and (min-width: 1600px){.bw-horizontal{flex-wrap:nowrap}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space-between": "bw-space-between",
	"horizontal": "bw-horizontal"
};
module.exports = ___CSS_LOADER_EXPORT___;
